import React from 'react';
import PropTypes from 'prop-types';

import {
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED,
  SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED,
} from 'common/applicationAssemblyLineConstants';

import SrCollapsibleContainer, {
  SR_COLLAPSIBLE_CONTAINER_STATUS_NOT_STARTED,
  SR_COLLAPSIBLE_CONTAINER_STATUS_COMPLETE,
  SR_COLLAPSIBLE_CONTAINER_STATUS_IN_PROGRESS,
  SR_COLLAPSIBLE_CONTAINER_STATUS_ERROR,
} from 'client/components/SrCollapsibleContainer/SrCollapsibleContainer';

const SR_APPLICATION_ASSEMBLY_LINE_STATUS_TO_SR_COLLAPSIBLE_CONTAINER_STATUS = {
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_STARTED]: SR_COLLAPSIBLE_CONTAINER_STATUS_NOT_STARTED,
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_IN_PROGRESS]: SR_COLLAPSIBLE_CONTAINER_STATUS_IN_PROGRESS,
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_NOT_QUALIFIED]: SR_COLLAPSIBLE_CONTAINER_STATUS_ERROR,
  [SR_APPLICATION_ASSEMBLY_LINE_STATUS_QUALIFIED]: SR_COLLAPSIBLE_CONTAINER_STATUS_COMPLETE,
};

const SrApplicationAssemblyLineContainer = ({
  title,
  titleColor,
  subtitle,
  isExpanded,
  hideIcon,
  status,
  borderType,
  children,
  onClick,
  onEditClick,
  editButtonTheme,
}) => {
  return (
    <SrCollapsibleContainer
      title={title}
      titleColor={titleColor}
      subtitle={subtitle}
      isExpanded={isExpanded}
      borderType={borderType}
      status={SR_APPLICATION_ASSEMBLY_LINE_STATUS_TO_SR_COLLAPSIBLE_CONTAINER_STATUS[status]}
      onClick={onClick}
      onEditClick={onEditClick}
      editButtonTheme={editButtonTheme}
      hideIcon={hideIcon}
    >
      {children}
    </SrCollapsibleContainer>
  );
};

SrApplicationAssemblyLineContainer.propTypes = {
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  subtitle: PropTypes.string,
  isExpanded: PropTypes.bool,
  status: PropTypes.string.isRequired,
  borderType: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  onEditClick: PropTypes.func,
  editButtonTheme: PropTypes.string,
};

SrApplicationAssemblyLineContainer.defaultProps = {
  isExpanded: false,
};

SrApplicationAssemblyLineContainer.displayName = 'SrApplicationAssemblyLineContainer';

export default SrApplicationAssemblyLineContainer;
